"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortProductBoxesByAvailability = void 0;
/**
 * Sorts product boxes by availability.
 * Products with quickBuy visible are always first.
 *
 * @param data ProductBoxProps[]
 */
const sortProductBoxesByAvailability = data => data.sort((a, b) => {
  if (a.buttons?.quickBuy?.visible && !b.buttons?.quickBuy?.visible) {
    return -1;
  }
  if (!a.buttons?.quickBuy?.visible && b.buttons?.quickBuy?.visible) {
    return 1;
  }
  return 0;
});
exports.sortProductBoxesByAvailability = sortProductBoxesByAvailability;
